import { useQuery } from '@tanstack/react-query';
import { useCustomMutation } from '../../hooks/useCustomMutation';
import * as ENDPOINTS from './endpoints';

export const QUERY_KEYS = {
  contributorNameAndJobRole: 'contributorNameAndJobRole',
  jobRoleNames: 'jobRoleNames',
};

export const useUpdateContributorNameAndJobRole = () => {
  return useCustomMutation(
    [QUERY_KEYS.contributorNameAndJobRole],
    ENDPOINTS.updateContributorNameAndJobRole
  );
};

export const useJobRoleNames = () => {
  return useQuery([QUERY_KEYS.jobRoleNames], ENDPOINTS.getJobRoleNames);
};
